<div style="text-align: center;">
    <div class="story-message">
        {{name}}
    </div>
    <img src="{{getImage()}}" width="{{diceWidth}}">
</div>
